import { useState, useEffect, useCallback, useRef } from "react";
import { useNavigate } from "react-router-dom";
import LogoutConfirmation from "../../components/LogoutConfirmation";
import PortalPopup from "../../components/PortalPopup";
import NavigationPanelLawyer from "../../components/NavigationPanelLawyer";
import { getCurrentUser } from "../../utils/getCurrentUser";
import Footer from "../../components/Footer.js";
import { Menu } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import CustomDropdown from "../../components/CustomDropdown";
import { documentService } from "../../services/documentService.js";
import CTAs from "../../components/CTAs.js";

const PreLBAChecks = () => {
  const [isLogoutConfirmationOpen, setLogoutConfirmationOpen] = useState(false);
  const user = getCurrentUser();
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10); // change if needed

  const navigate = useNavigate();
  const API_URL = process.env.REACT_APP_API_URL;
  const [clientList, setClientList] = useState([]);
  const statusOptions = [
    { value: "Identified", label: "Identified", color: "blue" },
    { value: "Pending", label: "Pending", color: "yellow" },
    { value: "Resolved", label: "Resolved", color: "green" },
  ];

  const closeLogoutConfirmation = useCallback(() => {
    setLogoutConfirmationOpen(false);
  }, []);

  useEffect(() => {
    const fetchTotalLBA = async () => {
      if (!user?.email) {
        console.error("User email is undefined");
        return;
      }

      const storedEmailId = user.email;
      console.log("Email", storedEmailId);

      try {
        const response = await fetch(
          `${API_URL}/api/law_firm/view-lba?email=${encodeURIComponent(
            storedEmailId
          )}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        const data = await response.json();

        const transformedData = data.map((item) => ({
          // Use formData._id as the primary ID
          id:
            item.formData._id ||
            item.formData.id ||
            Math.random().toString(36).substr(2, 9),
          name: item.formData?.name || "Unknown Firm",
          contact_details: item.formData?.email || "No Email",
          amount: item.formData?.amount,
          case_details: `${(
            item.firm?.formType || "Unknown"
          ).toUpperCase()} - ${item.formData?.invoiceNumber || "No Email"}`,
          status: item.formData?.status || "Pending",
          action: "View details Resolve Dismiss",
        }));

        setClientList(transformedData);
      } catch (error) {
        console.error("Error fetching total submitted count:", error);
      }
    };

    if (user?.email) {
      fetchTotalLBA();
    }
  }, [API_URL, user?.email]);
  const [selectedLbaId, setSelectedLbaId] = useState(null);
  const [documents, setDocuments] = useState([]);
  const [isLoadingDocs, setIsLoadingDocs] = useState(false);

  const handleViewDocuments = async (lbaId, clientData) => {
   console.log("clientData",clientData);
    setSelectedLbaId(lbaId);
    setIsLoadingDocs(true);

    try {
      const docs = await documentService.getDocuments(lbaId);
      setDocuments(docs);

      // Create state object with all the data you want to pass
      const navigationState = {
        documents: docs,
        name: clientData.name,
        email: clientData.address, // or clientData.email if available
        amount: clientData.amount, // make sure this field exists in your data
        currency: clientData.currency, // if available
        address: clientData.address, // if available
        // Include any other fields you need
        case_details: clientData.case_details,
        amount: clientData.amount,
        status: clientData.status,
      };

        navigate("/postprelbadet", {
        state: {
          lbaId,
          name: clientData.name,
          currency: clientData.currency,
          amount: clientData.amount,
          address: clientData?.address,
          userId:user?.id,
          email: clientData?.contact_details,
          lawyer:true
        },
        replace: true,
        
      });
    } catch (error) {
      console.error("Failed to fetch documents:", error);
    } finally {
      setIsLoadingDocs(false);
    }
  };

  const navItems = [
    {
      text: "Dashboard",
      bgColor: "bg-neutrals-neutral-50",
      textColor: "text-neutrals-neutral-300",
      hoverBgColor: "bg-neutrals-neutral-50",
      hoverTextColor: "text-primary-primary-500",
      path: "/dashboard",
    },
    {
      text: "Legal proceedings & billing",
      bgColor: "bg-neutrals-neutral-50",
      textColor: "text-neutrals-neutral-300",
      hoverBgColor: "bg-neutrals-neutral-50",
      hoverTextColor: "text-primary-primary-500",
      path: "/legal_1",
    },
    {
      text: "Pre-LBA checks",
      bgColor: "bg-primary-primary-50",
      textColor: "text-neutrals-neutral-900",
      hoverBgColor: "bg-primary-primary-50",
      hoverTextColor: "text-neutrals-neutral-900",
      path: "",
    },
    {
      text: "Client-debtor interaction",
      bgColor: "bg-neutrals-neutral-50",
      textColor: "text-neutrals-neutral-300",
      hoverBgColor: "bg-neutrals-neutral-50",
      hoverTextColor: "text-primary-primary-500",
      path: "/cdi1",
    },
  ];

  // For table
  const [activeTab, setActiveTab] = useState("all");
  const [searchQuery, setSearchQuery] = useState("");

  const filteredClient =
    activeTab === "all"
      ? clientList
      : clientList.filter(
          (debtor) => debtor.status.toLowerCase() === activeTab.toLowerCase()
        );

  const searchedClients = filteredClient.filter(
    (debtor) =>
      debtor.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      debtor.contact_details
        .toLowerCase()
        .includes(searchQuery.toLowerCase()) ||
      debtor.case_details.toLowerCase().includes(searchQuery.toLowerCase()) ||
      debtor.status.toLowerCase().includes(searchQuery.toLowerCase()) ||
      debtor.action.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const statusColorMap = {
    Identified: "bg-blue-100 text-blue-500 border-blue-500",
    Pending: "bg-yellow-100 text-yellow-600 border-yellow-500",
    Resolved: "bg-green-100 text-green-500 border-green-500",
  };

  const statusIconMap = {
    Identified: "•",
    Pending: "•",
    Resolved: "•",
  };

 // Updated handleStatusChange function in PreLBAChecks component
const handleStatusChange = async (id, newStatus) => {
  // Find the current client data
  const client = clientList.find(client => client.id === id);
  if (!client) return;

  const oldStatus = client.status;
  const newStatusValue = newStatus.value || newStatus;

  // Don't proceed if status hasn't actually changed
  if (oldStatus === newStatusValue) return;

  // Update local state immediately for better UX
  setClientList((prevList) =>
    prevList.map((client) =>
      client.id === id ? { ...client, status: newStatusValue } : client
    )
  );

  try {
    // Update status in database using your existing endpoint
    const statusResponse = await fetch(
      `${API_URL}/api/law_firm/updatedstatus/${id}`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ 
          status: newStatusValue,
          userId: user?.id // Make sure to include userId as per your backend
        }),
      }
    );

    if (!statusResponse.ok) {
      throw new Error("Failed to update status");
    }

    const result = await statusResponse.json();
    console.log("Status updated successfully:", result);

    // Your backend already handles the communication history logging
    // in the updateStatus method, so no need for separate API call

    // Optional: Show success message
    console.log(`Status changed from ${oldStatus} to ${newStatusValue}. Communication history recorded.`);

  } catch (error) {
    console.error("Error updating status:", error);

    // Revert the local state change if API call fails
    setClientList((prevList) =>
      prevList.map((client) =>
        client.id === id ? { ...client, status: oldStatus } : client
      )
    );

    alert("Failed to update status. Please try again.");
  }
};
const indexOfLastClient = currentPage * rowsPerPage;
const indexOfFirstClient = indexOfLastClient - rowsPerPage;
const currentClients = searchedClients.slice(indexOfFirstClient, indexOfLastClient);
const totalPages = Math.ceil(searchedClients.length / rowsPerPage);


  return (
    <>
      <div className="w-full relative bg-neutrals-neutral-50 min-h-screen overflow-visible text-left text-sm text-neutrals-neutral-900 font-open-sans-ff-body-strong">
        {/* Navigation Panel */}
        <NavigationPanelLawyer navItems={navItems} />

        {/* Main */}
        <div className="w-full absolute top-[136px] flex flex-col items-start justify-start gap-6 text-neutrals-neutral-900 px-4 md:px-4 lg:px-24 box-border">
          <div className="self-stretch bg-bg-primary border-neutrals-neutral-100 border-solid border-b-[1px] flex flex-col items-start justify-start pt-0 px-0 pb-6">
            <div className="self-stretch flex flex-row items-start justify-start">
              <div className="flex flex-col items-start justify-start gap-1.5">
                <b className="relative text-9xl">Pre-LBA checks</b>
                <div className="relative text-base text-neutrals-neutral-300">
                  Acknowledge defences and revert back.
                </div>
              </div>
            </div>
          </div>
          <div className="self-stretch flex flex-col items-start justify-start gap-8 text-lg">

            <div className="self-stretch flex flex-col items-start justify-start gap-6 text-base text-primary-primary-900">
              <div className="self-stretch relative font-semibold">
                Client list
              </div>
              <div className="self-stretch flex flex-col items-start justify-start gap-6 text-sm text-neutrals-neutral-300">
                <div className="w-full flex flex-row items-start justify-between gap-0">
                  <div className="w-[294px] shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] box-border flex flex-row items-center justify-start py-2.5 px-3.5">
                    <div className="flex flex-row items-center justify-start gap-2.5">
                      <img
                        className="w-5 relative h-5"
                        alt=""
                        src="assets/search.svg"
                      />
                      <div className="relative">Search clients/cases</div>
                    </div>
                  </div>
                  <div className="flex flex-row items-start justify-end gap-2.5 text-neutrals-neutral-900">
                    <div className="shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] flex flex-row items-center justify-start py-2.5 px-3.5 gap-1">
                      <div className="relative font-semibold">Show:</div>
                      <div className="flex flex-row items-center justify-start gap-1.5">
                        <div className="relative font-semibold">All</div>
                        <img
                          className="w-5 relative h-5 overflow-hidden shrink-0"
                          alt=""
                          src="assets/arrow-down.svg"
                        />
                      </div>
                    </div>
                    <div className="shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] flex flex-row items-center justify-center py-2.5 px-3.5">
                      <div className="flex flex-row items-center justify-center gap-1.5">
                        <img
                          className="w-5 relative h-5"
                          alt=""
                          src="assets/filter.svg"
                        />
                        <div className="relative font-semibold">Filter</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="self-stretch flex flex-col items-start justify-start text-neutrals-neutral-900">
                  <div className="self-stretch flex flex-row items-start justify-start">
                    <table className="min-w-full divide-y divide-gray-200 border-collapse">
                      <thead className="bg-column-bg">
                        <tr>
                          <th
                            scope="col"
                            className="items-start justify-start py-3 px-4 border-t-[1px] border-b-[1px] border-l-[1px] border-solid border-neutrals-neutral-100 font-open-sans-ff-meta-strong"
                          >
                            Client name
                          </th>
                          <th
                            scope="col"
                            className="items-start justify-start py-3 px-4 border-t-[1px] border-b-[1px] border-solid border-neutrals-neutral-100 font-open-sans-ff-meta-strong"
                          >
                            Contact details
                          </th>
                          <th
                            scope="col"
                            className="items-start justify-start py-3 px-4 border-t-[1px] border-b-[1px] border-solid border-neutrals-neutral-100 font-open-sans-ff-meta-strong"
                          >
                            Case details
                          </th>
                          <th
                            scope="col"
                            className="tems-start justify-start py-3 px-4 border-t-[1px] border-b-[1px] border-solid border-neutrals-neutral-100 font-open-sans-ff-meta-strong"
                          >
                            Status
                          </th>
                          <th
                            scope="col"
                            className="items-start justify-start py-3 px-4 border-t-[1px] border-r-[1px] border-b-[1px] border-solid border-neutrals-neutral-100 font-open-sans-ff-meta-strong"
                          >
                            Actions
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-neutrals-neutral-50 divide-y divide-gray-200">
                        {currentClients.map((client_list) => (
                          <tr key={client_list.id} className="hover:bg-gray">
                            <td className="p-4 items-start border-solid border-b-[1px] border-l-[1px] border-neutrals-neutral-100">
                              {client_list.name}
                            </td>
                            <td className="p-4 items-start border-solid border-b-[1px] border-neutrals-neutral-100">
                              {client_list.contact_details}
                            </td>
                            <td className="p-4 items-start border-solid border-b-[1px] border-neutrals-neutral-100">
                              {client_list.case_details}
                            </td>
                            <td className="p-4 items-start border-solid border-b-[1px] border-neutrals-neutral-100">
                              <CustomDropdown
                                value={
                                  statusOptions.find(
                                    (option) =>
                                      option.value === client_list.status
                                  ) || client_list.status
                                }
                                onChange={(newStatus) =>
                                  handleStatusChange(client_list.id, newStatus)
                                }
                                options={statusOptions}
                                width="w-36"
                                placeholder="Select status"
                              />
                            </td>
                            <td className="p-4 items-start border-solid border-b-[1px] border-r-[1px] border-neutrals-neutral-100 font-semibold">
                               <div className="flex items-center gap-3">
                                <button
                                  onClick={() => handleViewDocuments(client_list.id, client_list)}
                                  disabled={isLoadingDocs}
                                  className="inline-flex items-center px-4 py-2 bg-primary-primary-50 text-primary-primary-700 text-sm font-semibold rounded-3xs border border-primary-primary-200 hover:bg-primary-primary-100 hover:border-primary-primary-300 transition-colors duration-150 disabled:opacity-50 disabled:cursor-not-allowed"
                                >
                                  {isLoadingDocs && selectedLbaId === client_list.id ? (
                                    <>
                                      <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-primary-primary-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                      </svg>
                                      Loading...
                                    </>
                                  ) : (
                                    <>
                                      <img 
                                        src="assets/document.svg" 
                                        alt="Documents" 
                                        className="w-4 h-4 mr-2"
                                      />
                                      View Documents
                                    </>
                                  )}
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  {/* Pagination from here */}
                  <div className="w-full rounded-t-none rounded-b-3xs box-border flex flex-row items-center justify-between pt-3 px-6 pb-4 border-r-[1px] border-solid border-neutrals-neutral-100 border-b-[1px] border-l-[1px]">
                    <button
                      onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                      disabled={currentPage === 1}
                      className="shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-neutrals-neutral-50 flex flex-row items-center justify-center py-2.5 px-3.5 border-[1px] border-solid border-neutrals-neutral-100 disabled:opacity-50"
                    >
                      Previous
                    </button>

                    <div className="relative font-semibold">
                      Page {currentPage} of {totalPages || 1}
                    </div>

                    <button
                      onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                      disabled={currentPage === totalPages}
                      className="shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-neutrals-neutral-50 flex flex-row items-center justify-center py-2.5 px-3.5 border-[1px] border-solid border-neutrals-neutral-100 disabled:opacity-50"
                    >
                      Next
                    </button>
                  </div>

                </div>
              </div>
            </div>


          </div>
          <Footer />
        </div>
      </div>

      {isLogoutConfirmationOpen && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeLogoutConfirmation}
        >
          <LogoutConfirmation onClose={closeLogoutConfirmation} />
        </PortalPopup>
      )}
    </>
  );
};

export default PreLBAChecks;